<template>
    <div>
        <div style="position: fixed;">
            <div style="z-index: 0;">
                <v-img
                    :src="background"
                    :gradient="
                    backgroundColor
                "
                    height="100vh"
                    style="opacity: 0.9;"
                    class="bg-login"
                />
            </div>
        </div>
        <v-container
            fluid
            wrap
            :style="heightOverflow + 'padding: 0; margin: 0; position: relative;'">
            
            <v-layout
                column
                fill-height
                justify-center
                align-center>         
                <template v-if="!data">
                    <v-container fluid text-xs-center fill-height align-center style="padding: 0; margin: 0;">
                        <v-layout :style="{ height: heightCard, width: widthCard }" column fill-height justify-center align-center>
                            <v-flex xs12 sm12 md12 lg6 xl6>
                                <v-progress-circular :size="150" color="primary" indeterminate>
                                    <span>{{ strings[idioma].aguarde }}</span>
                                </v-progress-circular>
                            </v-flex>
                            <span style="font-weight: 500; padding: 4px;">
                                {{ strings[idioma].carregando_informacoes }}
                            </span>
                        </v-layout>
                    </v-container>
                </template>
                <template v-else>
                    <PendenciasUser />
                    <SessoesAlerta />
                    
                    <v-container v-if="user.consultor" style="min-width: 60vw; max-width: 70vw;" grid-list-md align-center text-xs-center>
                        <SelectCliente :titulo="strings[idioma].cliente" :$style="'position: relative; background-color: #fff; padding:10px; padding-top: 20px; border-radius: 10px; font-weight: 900; color: #000'" />
                    </v-container>

                    <v-container grid-list-md align-center text-xs-center>
                        <v-card>
                            <v-flex
                                v-if="
                                    (!user.consultor || user.consultor === null) &&
                                    user.plano &&
                                    user.plano !== null &&
                                    user.plano.data_inicio &&
                                    user.plano.data_final &&
                                    moment().diff(user.plano.data_final, 'days') > -10 &&
                                    moment().diff(user.plano.data_final, 'days') < 31 &&
                                    user.permissao !== 0 &&
                                    user.emp_user === null
                                "
                                style="opacity: 0.7;"
                                xs12
                            >
                                <AvisoPremium />
                            </v-flex>
                            <Banner />
                            <ExperimentePremium />
                        </v-card>

                        <v-tabs v-model="tab">
                            <v-tab>{{ strings[idioma].dietas_ativas }}</v-tab>
                            <v-tab :disabled="!getAcessoModulo({ user: user, modulo: SALVAR_DIETA })">{{ strings[idioma].dietas_predicoes_salvas }}</v-tab>
                            <v-tab :disabled="!getAcessoModulo({ user: user, modulo: SALVAR_DIETA })">{{ strings[idioma].comparar_dietas }}</v-tab>
                            <v-tab :disabled="!getAcessoModulo({ user: user, modulo: SALVAR_DIETA})">{{ strings[idioma].suplementos_salvos }}</v-tab>
                            <v-tab>{{ strings[idioma].meu_plano }}</v-tab>
                            <v-tab>{{ strings[idioma].apresentacao }}</v-tab>
                        </v-tabs>

                        <template v-if="tab === 0">
                            <v-layout v-if="dietasAtivas && dietasAtivas !== null && dietasAtivas.length > 0" row justify-center wrap>
                                <v-flex sm12>
                                    <v-card>
                                        <v-btn color="success" small flat @click="ocultarCard('DIETA_ATIVA', saveCardSettings)">{{ cardCanBeShow('DIETA_ATIVA') ? strings[idioma]['MINIMIZAR']: strings[idioma]['MOSTRAR_DIETAS_ATIVAS'] }}</v-btn>
                                        <DietasCard v-if="cardCanBeShow('DIETA_ATIVA')" type="DIETAS_ATIVAS" />
                                    </v-card>
                                </v-flex>
                            </v-layout>
                        </template>
                        <template v-if="tab === 1 && getAcessoModulo({ user: user, modulo: SALVAR_DIETA })">
                            <v-layout row justify-space-around pb-2 wrap>
                                <v-flex v-if="possuiDietas" :lg6="possuiPredicoes" :xl6="possuiPredicoes" :lg12="!possuiPredicoes" :xl12="!possuiPredicoes" :md6="possuiPredicoes" xs12>
                                    <v-card>
                                        <v-btn color="primary" small flat @click="ocultarCard('DIETA', saveCardSettings)">{{ cardCanBeShow('DIETA') ? strings[idioma]['MINIMIZAR']: strings[idioma]['MOSTRAR_DIETAS_SALVAS'] }}</v-btn>
                                        <DietasCard v-if="cardCanBeShow('DIETA')" />
                                    </v-card>
                                </v-flex>
                                <v-flex v-if="possuiPredicoes" :lg6="possuiDietas" :xl6="possuiDietas" :lg12="!possuiDietas" :xl12="!possuiDietas" :md6="possuiDietas" xs12>
                                    <v-card>
                                        <v-btn color="black" small flat @click="ocultarCard('PREDICAO', saveCardSettings)">{{ cardCanBeShow('PREDICAO') ? strings[idioma]['MINIMIZAR']: strings[idioma]['MOSTRAR_PREDICOES_SALVAS'] }}</v-btn>
                                        <PredicoesCard v-if="cardCanBeShow('PREDICAO')" />
                                    </v-card>
                                </v-flex>
                            </v-layout>
                        </template>
                        <template v-if="tab === 2">
                            <CompararDietas />
                            <DashboardStart />
                        </template>
                        <template v-if="tab === 3 && getAcessoModulo({ user: user, modulo: SALVAR_DIETA })">
                            <SuplementosCard />
                        </template>
                        <template v-if="tab === 4">
                            <v-card>
                                <AvisoPremium />
                                <Premium />
                            </v-card>
                        </template>
                        <template v-if="tab === 5">
                            <v-card style="padding: 10px;">
                                <Apresentacao v-if="$store.state.app.exibeConteudoApresentacao" style="text-align: justify;" />
                            </v-card>
                        </template>
                    </v-container>
                    <DashboardStats />
                    <PostsWP v-if="$store.state.app.exibeBlog" />
                </template>
            </v-layout>
        </v-container>
    </div>
</template>


<script>
    import { mapState } from "vuex";
    import { GRAFICOS_DASHBOARD, SALVAR_DIETA } from "../utils/types";
    import Apresentacao from "./statics/instrucoes/Apresentacao"
    import CompararDietas from "./components/CompararDietas";
    import DietasCard from "./components/DietasCard";
    import PredicoesCard from "./components/PredicoesCard";
    import moment from "moment";
    import SuplementosCard from "./components/SuplementosCard.vue";
    import PendenciasUser from "./components/PendenciasUser.vue";

    import DashboardStart from "./components/DashboardStart.vue";
    import SelectCliente from "./consultor/components/SelectCliente.vue";
    import Banner from "./components/Banner.vue";
    import ExperimentePremium from "./components/ExperimentePremium.vue";
    import AvisoPremium from "./components/AvisoPremium.vue";
    import Premium from "./Premium.vue";
    import DashboardStats from "./components/DashboardStats.vue";
    import PostsWP from "./components/PostsWP.vue";
    import SessoesAlerta from "./components/SessoesAlerta.vue";
    import { getData } from '@/utils/utils'
    export default {
        components: {
            CompararDietas,
            DietasCard,
            PredicoesCard,
            SuplementosCard,
            DashboardStart,
            SelectCliente,
            PendenciasUser,
            Banner,
            ExperimentePremium,
            AvisoPremium,
            Premium,
            Apresentacao,
            DashboardStart,
            DashboardStats,
            PostsWP,
            SessoesAlerta
        },
        data() {
            return {
                tab: 0,
                linkURL: null,
                loadingAlimentos: false,
                searchDieta: null,
                searchPredicao: null,
                searchTabela: null,
                // logo: process.env.VUE_APP_LOGO_AZUL ? process.env.VUE_APP_LOGO_AZUL : 'img/brcorte-logo.png',
                logo: process.env.VUE_APP_LOGO_BRANCA ? process.env.VUE_APP_LOGO_BRANCA : "img/brcorte5-logobranca.png",
                background: "img/background-login.jpg",
                backgroundColor: process.env.VUE_APP_BG ? process.env.VUE_APP_BG : "to top right, rgba(100,115,201,.2), rgba(25,32,72,.7)",
                SALVAR_DIETA: SALVAR_DIETA,
                GRAFICOS_DASHBOARD: GRAFICOS_DASHBOARD,
                cards: {
                    DIETA_ATIVA: true,
                    DIETA: true,
                    PREDICAO: true,
                },
            };
        },
        computed: {
            ...mapState("app", [
                "dietasAtivas",
                "data",
                "acesso_premium",
                "strings",
                "idioma",
                "user",
                "ingredientes",
                "optionsNumber",
                "alimentos_selecionados",
                "categorias_alimentos",
                "alimentos_usuario",
                "alert",
                "dietas",
                "predicoes",
                "tabelas",
                "empresa",
                "tabHome",
                "exibeTesteGratis",
            ]),
            predicoesSalvas() {
                return this.predicoes !== null ? this.predicoes.filter((p) => p.user_id === this.user.id) : [];
            },
            possuiPredicoes() {
                return this.predicoes && this.predicoes.length >= 0 && this.predicoesSalvas.length > 0;
            },
            dietasSalvas() {
                return this.dietas !== null ? this.dietas.filter((p) => p.user_id === this.user.id) : [];
            },
            possuiDietas() {
                return this.dietas && this.dietas.length >= 0 && this.dietasSalvas.length > 0;
            },
            heightOverflow() {
                return "max-height: " + String(this.$vuetify.breakpoint.height - 50) + "px; overflow: auto;";
            },
            heightCard () {
                return String(this.$vuetify.breakpoint.height - 80) + 'px'
            },
            widthCard () {
                return String(this.$vuetify.breakpoint.width - 300) + 'px'
            },
        },
        mounted() {
            let backgrounds = [
                "img/background-bois.jpg",
                "img/gado-background.jpg",
                "img/background-login.jpg",
                "img/Ocasião_da_SH_e_Batuque_do_R.I..jpg",
                "img/IMG-20180329-WA0001.jpg",
                "img/IMG-20180330-WA0012.jpg",
                "img/IMG-20181118-WA0008.jpg",
            ];
            this.background = backgrounds[parseInt(Math.random() * 100) % backgrounds.length];
            this.getData().then(() => {
                if (this.getAcessoModulo({ user: this.user, modulo: SALVAR_DIETA })) {
                    this.tab = this.dietasAtivas && this.dietasAtivas.length > 0 ? 0 : 1
                } else {
                    this.tab = this.dietasAtivas && this.dietasAtivas.length > 0 ? 0 : 4
                }
            })
            this.$store.dispatch("getDietasAtivas");
        },
        methods: {
            getData () {
                this.$store.state.app.tabHome = -1
                return getData(this.$store.state, this.axios)
            },
            moment(...args) {
                return moment(...args);
            },
            cardCanBeShow(tipo) {
                return this.cards[tipo];
            },
            getCardSettings(handle = null) {
                let conf = localStorage.getItem("cardSettings");
                let ret = null;
                if (!conf) ret = this.cards;
                else ret = JSON.parse(conf);
                if (handle !== null) handle(ret);
                return ret;
            },
            saveCardSettings() {
                localStorage.setItem("cardSettings", JSON.stringify(this.cards));
            },
            ocultarCard(tipo, handle = null) {
                this.cards[tipo] = !this.cards[tipo];
                if (handle !== null) handle(this.card);
                return this.cards[tipo];
            },
        },
    };
</script>
